<template lang="pug">
  menu-bar-item(:label=`$t('background')`)
    menu-item(:label=`$t('none')`, type="radio", v-model="frameStore.type", value="NONE")
    menu-separator
    menu-item(:label=`$t('gaia_dr2')`, type="radio", v-model="frameStore.type", value="GAIA_DR2")
    menu-item(:label=`$t('eso_milky_way_panoram')`, type="radio", v-model="frameStore.type", value="ESO_MILKY_WAY")
    menu-item(:label=`$t('mitaka_campus_by_satoshi_kawanomoto')`, type="radio", v-model="frameStore.type", value="KAWANOMOTO1")
    menu-separator
    menu-item(:label=`$t('fade')`, :disabled="!frameStore.hips", v-model="frameStore.fade")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FrameStore } from "@/modules/base";
import { BackgroundModule } from "@/modules/BackgroundModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof BackgroundModule>
}
</script>



<style lang="scss" scoped>
a {
  margin-left: 1em;
}
</style>

<i18n>
en:
  background: Background
  none: None
  gaia_dr2: Gaia DR2
  eso_milky_way_panoram: ESO Milky Way Panoram
  mitaka_campus_by_satoshi_kawanomoto: Mitaka Campus by Satoshi Kawanomoto
  fade: Fade
ja:
  background: 背景
  none: なし
  gaia_dr2: Gaia DR2
  eso_milky_way_panoram: 天の川（ESOのデータ）
  mitaka_campus_by_satoshi_kawanomoto: 国立天文台三鷹グラウンド（by 川野元聡）
  fade: 拡大時に薄くする

</i18n>